var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkColorDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VK"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vk-color-dark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VK.com-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M13.1733 6H24.8267C35.4667 6 38 8.53333 38 19.1733V30.8267C38 41.4667 35.4667 44 24.8267 44H13.1733C2.53333 44 0 41.4667 0 30.8267V19.1733C0 8.53333 2.53333 6 13.1733 6Z",
    fill: "#5181B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M31.1192 19.0915C31.2953 18.5044 31.1192 18.073 30.2813 18.073H27.5104C26.8059 18.073 26.4811 18.4457 26.3049 18.8566C26.3049 18.8566 24.8959 22.2912 22.8998 24.5222C22.254 25.1679 21.9604 25.3734 21.6081 25.3734C21.432 25.3734 21.1771 25.1679 21.1771 24.5809V19.0915C21.1771 18.387 20.9726 18.073 20.3854 18.073H16.0313C15.591 18.073 15.3262 18.4 15.3262 18.7099C15.3262 19.3778 16.3242 19.5318 16.4271 21.4105V25.4909C16.4271 26.3855 16.2655 26.5477 15.9133 26.5477C14.9739 26.5477 12.689 23.0978 11.3339 19.1502C11.0683 18.3829 10.8019 18.073 10.0938 18.073H7.32293C6.53127 18.073 6.37292 18.4457 6.37292 18.8566C6.37292 19.5905 7.3123 23.2306 10.7468 28.0448C13.0365 31.3325 16.2624 33.1147 19.1979 33.1147C20.9592 33.1147 21.1771 32.7188 21.1771 32.037V29.5522C21.1771 28.7605 21.344 28.6025 21.9017 28.6025C22.3126 28.6025 23.0172 28.808 24.6611 30.3932C26.5398 32.2719 26.8495 33.1147 27.9063 33.1147H30.6771C31.4688 33.1147 31.8646 32.7188 31.6363 31.9377C31.3864 31.1591 30.4894 30.0296 29.2992 28.6906C28.6533 27.9273 27.6846 27.1054 27.3911 26.6944C26.9801 26.1661 27.0975 25.9312 27.3911 25.4615C27.3911 25.4615 30.7669 20.706 31.1192 19.0915Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkColorDark);
export default __webpack_public_path__ + "static/media/vk-color-dark.fd08f3840daa1dc28e6544a30c3c0812.svg";
export { ForwardRef as ReactComponent };